<template>
    <div class="">
        <div class="icp flex jucen alcen sz14" >
            <span @click="gotoBeian" class="cursor">粤公网安备44030002010518号</span>&nbsp;&nbsp; 
            <span>&copy;</span><span class="cursor" @click="tabstuts = true">粤ICP证B2-20221563号</span>&nbsp;&nbsp; <span
                class="cursor" @click="gotoicp">粤ICP备2022060300号-2</span>&nbsp;&nbsp;<span>深圳自在必得科技有限公司</span>
        </div>
        <div class="icp flex jucen alcen sz14">
            &nbsp;&nbsp;<span>电话: 18025384089</span>
                &nbsp;&nbsp;<span>地址: 深圳市龙岗区坂田街道南坑社区雅宝路1号星河WORLDF栋大厦1301-2A（2）</span>
        </div>
        <div class="icoimg" v-if="tabstuts">
            <div class="topimg">
                <div class="gubi ru50 flex jucen alcen cursor" @click="tabstuts = false"><i
                        class="el-icon-close coff"></i></div>
                <img src="@/assets/img/home/icp.jpg" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tabstuts: false
        }
    },
    methods: {
        gotoicp() {
            window.open('https://beian.miit.gov.cn/#/Integrated/index')
        },
        gotoBeian() {
            window.open('https://beian.mps.gov.cn/#/query/webSearch?code=44030002010518')
        }
    }
}
</script>
<style lang="less" scoped>
.icp {
    width: 100%;
    // height: 50px;
    margin-bottom: 4px;
}

.icoimg {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    top: 0;
    z-index: 9999;
    overflow: auto;

    .topimg {
        width: 800px;
        height: 1200px;
        margin: 0 auto;
        padding-top: 100px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .gubi {
        width: 30px;
        height: 30px;
        border-radius: 50;
        position: absolute;
        right: -50px;
        top: 50px;
        border: 1px solid #fff;
    }


}

.icoimg::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background: #a6a8bf;
}

.icoimg::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
}

.icoimg::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}
</style>
